// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — range.styled.classic.js, новая — range.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './range.styled.classic';
import * as cp from './range.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const Thumb = isCp ? cp.Thumb : classic.Thumb;
export const Track = isCp ? cp.Track : classic.Track;
